<template>
	<div v-if=" showList " id="ListView" class="relative">
		<div class="relative overflow-auto min-h-[100%]">
			<EwLoadingOverlay v-if=" loading " />

			<div class="mx-auto pb-3 border-b bg-coolgray-100" :class="{ 'pt-4': collectionModeData?.hideHeader }">
				<div v-if="!collectionModeData?.hideHeader" class="flex md:flex-row flex-col-reverse md:items-center gap-3 md:gap-0 p-4" 
					>
						<LanguageSwitcher v-if="!collectionModeData?.hideHeaderLanguageSwitch" :class="{ 'disabled' : collectionModeData?.disabledLnguageSwitcher }" :languages="languageList" />
						<ListFiltersView  
						:class="{ 'md:ml-auto': collectionModeData?.hideHeaderSearch || collectionModeData?.hideHeaderActions ? 'md:mx-auto' : 'md:ml-auto' }"   
						:collectionModeData="collectionModeData"
 						v-model="listFilters" @search="searchFilters" @clear-filters="clearFilters"
						v-model:showFilters="showFilters"  />

						<div  v-if=" !collectionModeData?.hideHeaderPlaylistButton || !collectionModeData?.hideHeaderActions " class="flex items-center"   :class="{ 'ml-auto': collectionModeData?.hideHeaderSearch || collectionModeData?.hideHeaderFilters ? 'mx-auto' : 'ml-auto' }" >
							<div class="flex items-center flex-wrap gap-2">
								<!-- <button type="button" v-if="!isTextOnlyOutput && !AppConfig.models"
									class="inline-flex !bg-black items-center gap-2 rounded py-2 px-3 text-center align-middle font-sans text-xs font-bold uppercase text-white transition-all !hover:bg-black/60 hover:text-white"
									v-tooltip.bottom="labels.quizesmode" @click="goToQuizes()">
									<i class="tabler:list-check w-5 h-5"></i>
								</button> -->
								<button type="button" v-if=" !isTextOnlyOutput && !AppConfig.models && !collectionModeData?.hideHeaderPlaylistButton"
									class="inline-flex !bg-black items-center gap-2 rounded py-2 px-3 text-center align-middle font-sans text-xs font-bold uppercase text-white transition-all !hover:bg-black/60 hover:text-white"
									v-tooltip.bottom="labels.playermode" @click="goToPlaylist()">
									<i class="tabler:headphones w-5 h-5"></i>
								</button>
								
								<button type="button"
									class="btn btn-outline-primary py-2 px-3 inline-flex text-center align-middle font-sans text-xs font-bold uppercase"
									v-tooltip.bottom="labels.simpleList" v-if="!collectionModeData?.hideHeaderActions"
									:class="{ 'bg-primary text-white': displayType === 'list' }"
									@click="setDisplayType( 'list' )">
									<i class="tabler:list-details w-5 h-5"></i>
								</button>
								<button type="button"
									class="btn btn-outline-primary py-2 px-3 inline-flex text-center align-middle font-sans text-xs font-bold uppercase"
									v-tooltip.bottom="labels.groupList" v-if="!collectionModeData?.hideHeaderActions"
									:class="{ 'bg-primary text-white': displayType === 'grid' }"
									@click="setDisplayType( 'grid' )">
									<i class="tabler:layout-grid w-5 h-5"></i>
								</button>
							</div>
						</div>
				</div>
				<div :class="{ 'px-2': AppConfig.editmode ? 'px-2' : 'px-4' }" >
					<template v-if=" displayType === 'list' ">
						<div class="text-gray-700 flex flex-col gap-2">
							<div v-if=" noResults "
								class="relative inset-0 flex items-center justify-center h-[100%] z-1">
								<div
									class="text-xl bg-white rounded-2 p-4 font-semibold !text-danger-800 flex items-center">
									<i class="tabler:alert-triangle mr-2 w-5 h-5"></i> {{ labels.noResults }}</div>
							</div>
							<keep-alive>
								<PostItem
									class="transition transition-duration-1000 transition-ease-linear transition-opacity-100"
									v-for=" ( callout ) in jsonDataFiltered " :key="callout.identifier"
									:callout="callout" :isTextOnlyOutput="isTextOnlyOutput"
									:isPlaying="playingId === callout.identifier" :selectedLanguage="currentLng"
									:medicalSpeciality="currentMedicalFilter"
									:publishingStatus="currentPublishingFilter"
									:authoringStatus="currentAuthoringFilter" :studyType="currentStudyType"
									:outcomeType="currentoutcomeType" :configcollection="collectionModeData"
									:isEditMode="collectionModeData?.editmode" :hideActions="AppConfig.hideActions"
									@statusesChange="onStatusesChange"
									@play="handleTogglePlayback" @delete="handleDelete"
									:authoringStatusOptions="authoringStatusOptions"
									:reviewStatusOptions="reviewStatusOptions"
									:publishingStatusOptions="publishingStatusOptions"
									@toPresentation="goToPresenation" />
									

							</keep-alive>
							<Pagination v-if=" jsonData && !noResults && !collectionModeData?.hidePagination " :totalRecords="totalRecords" :rows="itemsPerPage"
								:currentPage="currentPage" @update:currentPage="( page ) => {
									currentPage = page;
									fetchDataWithFilters();
								}">
							</Pagination>

							<!-- <div class="text-center">
								<button class="text-center font-semibold flex mx-auto btn btn-primary p-2 rounded-full"
									:disabled="allItemsLoaded" @click="loadMore">
									<svg v-if=" loading " aria-hidden="true"
										class="w-5 h-5 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600 mr-2"
										viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path
											d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
											fill="currentColor" />
										<path
											d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
											fill="currentFill" />
									</svg>
									{{ loading ? labels.loading : allItemsLoaded ? labels.noItemsMore : labels.loadMore }}
									<i class="tabler:circle-chevrons-down w-6 h-6 flex"></i>

								</button>
							</div> -->
						</div>
					</template>
					<template v-if=" displayType === 'grid' ">
						<div class="text-gray-700 grid grid-cols-3 gap-2">
							<GridPostItem v-for=" ( callout, index ) in jsonDataFiltered " :key="callout.identifier"
								:callout="callout" :isTextOnlyOutput="isTextOnlyOutput"
								:isPlaying="playingId === callout.identifier" :selectedLanguage="currentLng"
								:isEditMode="AppConfig.editmode" @play="handleTogglePlayback"
								@toPresentation="goToPresenation" />
						</div>
						<!-- 
						<button class="text-center font-semibold flex mx-auto btn btn-primary mt-4 p-2"
							:disabled="allItemsLoaded" @click="loadMore">
							<svg v-if=" loading " aria-hidden="true"
								class="w-5 h-5 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600 mr-2"
								viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path
									d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
									fill="currentColor" />
								<path
									d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
									fill="currentFill" />
							</svg>
							{{ loading ? labels.loading : allItemsLoaded ? labels.noItemsMore : labels.loadMore }}
							<i class="tabler:arrow-big-down w-6 h-6 flex"></i>
						</button> -->
							<Pagination v-if=" jsonData && !noResults && !collectionModeData?.hidePagination" :totalRecords="totalRecords" :hidePagination="AppConfig.hidePagination" :rows="itemsPerPage"
								:currentPage="currentPage" @update:currentPage="( page ) => {
									currentPage = page;
									fetchDataWithFilters();
								}">
							</Pagination>


					</template>
				</div>
			</div>
		</div>
	</div>
	<router-view v-slot=" { Component, route } ">
		<component :is="Component" :selectedLanguage="currentLng" :id="route.params.id" v-bind="presentationData" />
	</router-view>
</template>

<script setup lang="ts">
import { ref, onMounted, computed, watch, provide } from 'vue';
import { useEventBus } from '@vueuse/core';
import { useRoute, useRouter } from 'vue-router';
import axios from 'axios'
import EditButton from '@/components/EditButton.vue';
// import ShowNavButton from '@/components/ShowNavButton.vue';
import LanguageSwitcher from '@/components/LanguageSwitcher.vue';
import EwLoadingOverlay from '@/components/EwLoadingOverlay.vue'
// import FilterPublishingStatus from '@/components/Filters/FilterPublishingStatus.vue';
// import FilterAuthoringStatus from '@/components/Filters/FilterAuthoringStatus.vue';
// import FilterPackageType from '@/components/Filters/FilterPackageType.vue';
import PostItem from '@/components/PostItem.vue';
import GridPostItem from '@/components/GridPostItem.vue';
import ListFiltersView from '@/components/Filters/ListFilters.vue'
import Pagination from '@/components/Pagination.vue';
import { messages } from '@/assets/language';
import { useAppConfig } from '@/composables/useAppConfig';

import { getSpecificPostParams } from '@/utils';
import type { Callout, CVResponse, ListFilters, PostListResponse, LanguageItem, configCollectionMode } from '@/types';
import type { AuthoringStatusList, ReviewStatusList, PublishingStatusList } from '@/types/cvTypes';
import { CVDataProvided } from '@/types/cvTypes';
import { useAppStore } from '@/stores/app-store'

import Swal from 'sweetalert2';

//import ZoneChange from '@/components/Filters/ZoneChange.vue';

const route = useRoute();
const router = useRouter();
const bus = useEventBus<Record<string, any>>( 'saved' );

const AppConfig = useAppConfig();

const { currentLng, currentMedicalFilter, currentStudyType, currentstudyMode, currentoutcomeType, currenttargetAudience, currentPublishingFilter, currentAuthoringFilter, currentaplicationDomain, currentDataFilter, currentLatestDays, currentCollectionMode, currentTestyourself, currentPAGE_REQ_ID } = useAppStore()

const filters = [
	currentLng,
	currentPublishingFilter,
	currentAuthoringFilter,
	currentMedicalFilter,
	currentStudyType,
	currentstudyMode,
	currentoutcomeType,
	[currenttargetAudience],
	currentaplicationDomain,
	currentDataFilter,
	currentLatestDays,
	currentCollectionMode,
	currentTestyourself,
	currentPAGE_REQ_ID
	
];

filters.forEach( ( filter ) => {
	watch( filter, () => {
		fetchDataWithFilters();
	} );
} );
type StatusCode = 'n'|'d'|'e'|'f';

function onStatusesChange(payload: { id: string; authoring: string; review: string; publishing: string }) {
  fetchDataWithFilters();
}


const props = defineProps<{
	selectedStatus: string;
	selectedPublishingStatus: string;
	selectedPackageType: string;
}>();


const authoringStatusOptions = ref<AuthoringStatusList[]>( [] )
const reviewStatusOptions = ref<ReviewStatusList[]>( [] )
const publishingStatusOptions = ref<PublishingStatusList[]>( [] )

async function fetchStatusOptions () {
	try {
		const [authoringRes, reviewRes, publishingRes] = await Promise.all( [
			axios.get( `${AppConfig.urls.authoringStatuscfg?.authoringStatus}?json=y` ),
			axios.get( `${AppConfig.urls.reviewStatuscfg?.reviewStatus}?json=y` ),
			axios.get( `${AppConfig.urls.publishingStatuscfg?.publishingStatus}?json=y` )
		] );

		authoringStatusOptions.value = authoringRes.data?.data || [];
		reviewStatusOptions.value = reviewRes.data?.data || [];
		publishingStatusOptions.value = publishingRes.data?.data || [];
	} catch ( error ) {
		console.error( 'Failed to fetch status options:', error );
	}
}



function onPropSaved ( event: Record<string, any> ) {
	console.log( event );
	fetchDataWithFilters();
}
const unsubscribe = bus.on( onPropSaved );

const labels = computed( () => {
	const key = currentLng.value as keyof typeof messages
	return messages[key] ?? {}
} );

const showFilters = ref<boolean>( false );

const searchTriggered = ref( false );

const searchFilters = () => {
	stopInlineAudioPlayback()
	searchTriggered.value = true
	noResults.value = false
	fetchDataWithFilters()
	setTimeout( () => {
		showFilters.value = false
	}, 300 );
}
const clearFilters = () => {
	listFilters.value = defaultFIlters()
	noResults.value = false
	searchFilters()
}


const defaultFIlters = () => ( {
	search: null,
	author: [],
	outcomeType: [],
	targetAudience: [],
	inputMaterialType: [],
	allStatuses: null
} )
const listFilters = ref<ListFilters>( defaultFIlters() )
watch( listFilters, () => {
	if ( searchTriggered.value ) {
		console.log( 'u trigerua funksioni' )
		fetchDataWithFilters();
	}
}, { deep: true } )


const displayType = ref<'list' | 'grid'>( ( localStorage.getItem( 'displayType' ) as 'list' | 'grid' ) || 'list' );
const setDisplayType = ( type: 'list' | 'grid' ) => {
	displayType.value = type;
	localStorage.setItem( 'displayType', type ); // Ruaje në localStorage
};

watch( displayType, ( newValue ) => {
	localStorage.setItem( 'displayType', newValue );
} );


// * Get the specific post id from the query string
const specificPost = ref<string | null>( getSpecificPostParams( 'post', window.location.search ) );
// * Check if the output should be text only. Set in URL query string as `textonly=true`. This will hide the audio player and presentation player buttons
const isTextOnlyOutput = ref<boolean>( !!getSpecificPostParams( 'textonly', window.location.search ) );

const jsonData = ref<Callout[]>();
const CVData = ref<CVResponse>( { data: {} } );
const collectionModeData = ref<configCollectionMode | null>(null);
const languageList = ref<LanguageItem[]>( [] );


provide( CVDataProvided, CVData )

const currentPage = ref( 1 ); // faqja aktuale
const totalRecords = ref( 0 ); // numri total i rezultateve
const itemsPerPage = computed(() => {
  const isFiltered = ['latest', 'next', 'working'].includes(currentDataFilter.value);

  if (isFiltered) {
    return displayType.value === 'list' ? 1 : 3;
  }

  return displayType.value === 'list' ? 10 : 3;
});

const jsonDataFiltered = computed( () => jsonData.value ?? [] );
const loading = ref( false );
const noResults = ref( false )

type ListRequestSnapshot = {
	page: number
	limit: number
	params: Record<string, any>
}

type FetchListOptions = {
	preserveOnMalformedEmpty?: boolean
	preserveWhenPageDrops?: boolean
}

const cloneParams = (params: Record<string, any>) => {
	const cloned: Record<string, any> = {}
	Object.entries(params).forEach(([key, value]) => {
		if (Array.isArray(value)) {
			cloned[key] = [...value]
		} else if (value && typeof value === 'object') {
			cloned[key] = { ...value }
		} else {
			cloned[key] = value
		}
	})
	return cloned
}

const lastRequestSnapshot = ref<ListRequestSnapshot | null>(null)


const fetchDataWithFilters = async (snapshot?: ListRequestSnapshot, options: FetchListOptions = {}) => {
	loading.value = true;
	const preserveOnMalformedEmpty = options.preserveOnMalformedEmpty ?? false;
	const preserveWhenPageDrops = options.preserveWhenPageDrops ?? false;

	try {
		let limit = itemsPerPage.value;

		if (['latest', 'next', 'working'].includes(currentDataFilter.value)) {
			if (displayType.value === 'list') {
				limit = 1;
			} else {
				limit = 3;
			}
		}

		const requestPage = snapshot?.page ?? currentPage.value;
		const offset = snapshot?.params?.offset ?? (requestPage - 1) * limit;

		let params: Record<string, any> = snapshot
			? {
				...cloneParams(snapshot.params),
				offset,
				limit: snapshot.limit
			}
			: {
				...route.query,
				...listFilters.value,
				'collection-mode': currentCollectionMode.value,
				testYourself: currentTestyourself.value,
				PAGE_REQ_ID: currentPAGE_REQ_ID.value,
				offset,
				limit
			};

		if (snapshot) {
			limit = snapshot.limit;
		}

		delete params.page;
		delete params.detailsUrl;
		delete params.detailsKey;

		if (!snapshot) {
			if (currentMedicalFilter.value) {
				params.medicalSpeciality = currentMedicalFilter.value;
			}
			if (currentPublishingFilter.value) {
				params.publishingStatus = currentPublishingFilter.value;
			}
			if (currentAuthoringFilter.value) {
				params.authoringStatus = currentAuthoringFilter.value;
			}
			if (currentStudyType.value) {
				params.currentStudyType = currentStudyType.value;
			}
			if (currentstudyMode.value) {
				params['flag-mode'] = currentstudyMode.value;
			}
			if (currentoutcomeType.value) {
				params.outcomeType = currentoutcomeType.value;
			}
			if (currenttargetAudience.value) {
				params.targetAudience = [currenttargetAudience.value];
			}
			if (currentaplicationDomain.value) {
				params.aplicationDomain = [currentaplicationDomain.value];
			}
			if (currentDataFilter.value) {
				params['dashboard-filter'] = currentDataFilter.value;
			}
			if (currentLatestDays.value) {
				params['latest-days'] = currentLatestDays.value;
			}
			if (listFilters.value.allStatuses?.length) {
				params.statuses = listFilters.value.allStatuses;
			}
		}

		const response = await axios.get<PostListResponse>(`${AppConfig.urls.getList}?json=y`, {
			params,
			headers: {
				'Content-Type': 'application/json',
				'Accept-Language': currentLng.value
			}
		});

		const incomingData = response.data.data ?? [];
		const incomingCV = response.data.CV;
		const incomingLanguages = response.data.CV?.data?.language ?? [];
		const incomingConfig = response.data.config;
		const pagination = response.data.meta?.pagination;
		const recordsMeta = pagination?.records;
		const hasResults = incomingData.length > 0;
		const inferredTotal = recordsMeta?.total
			?? (typeof pagination?.last === 'number' ? pagination.last * limit : 0);
		const nextTotalRecords = Number(inferredTotal ?? 0);
		const snapshotOffset = snapshot ? (snapshot.page - 1) * snapshot.limit : 0;

		if (preserveOnMalformedEmpty && snapshot && !hasResults && !recordsMeta && (jsonData.value?.length ?? 0) > 0) {
			console.warn('Ignoring malformed empty list response after modal close refresh', { params });
			return;
		}
		// Some modal-close refreshes on page 1 occasionally return partial data without pagination metadata.
		// Keep the previous snapshot in this case to avoid collapsing the visible list.
		if (
			preserveWhenPageDrops &&
			snapshot &&
			snapshot.page === 1 &&
			!recordsMeta &&
			hasResults &&
			(jsonData.value?.length ?? 0) > 0 &&
			incomingData.length < (jsonData.value?.length ?? 0)
		) {
			console.warn('Ignoring malformed partial first-page response after modal close refresh', {
				params,
				incoming: incomingData.length,
				previous: jsonData.value?.length ?? 0
			});
			return;
		}
		if (preserveWhenPageDrops && snapshot && nextTotalRecords <= snapshotOffset && (jsonData.value?.length ?? 0) > 0) {
			console.warn('Ignoring page-drop response after modal close refresh', { params, nextTotalRecords, snapshotOffset });
			return;
		}

		jsonData.value = incomingData;
		CVData.value = incomingCV;
		languageList.value = incomingLanguages;
		collectionModeData.value = incomingConfig;

		console.log('🌐 collectionModeData.lng:', collectionModeData.value?.lng);

		if (collectionModeData.value?.lng) {
			currentLng.value = collectionModeData.value.lng;
		}

		totalRecords.value = nextTotalRecords;
		noResults.value = !incomingData || incomingData.length === 0;
		currentPage.value = requestPage;

		lastRequestSnapshot.value = {
			page: requestPage,
			limit,
			params: cloneParams(params)
		};
	} catch (error) {
		console.error('Failed to fetch data', error);
	} finally {
		loading.value = false;
		searchTriggered.value = false;
	}
};



const handleDelete = async ( url: string ) => {
	console.log( 'Handle delete called with URL:', url ); // Kontrollo nëse funksioni është thirrur
	try {
		const result = await Swal.fire( {
			title: 'Are you sure?',
			text: 'Are you sure you want to delete this post?',
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: "#4679cc",
			cancelButtonColor: "#d33",
			confirmButtonText: 'Yes, Delete it!',
			cancelButtonText: 'No, Cancel!',
		} );

		if ( result.isConfirmed ) {
			const response = await fetch( url, {
				method: 'DELETE',
			} );

			if ( !response.ok ) {
				const errorMessage = `Error: ${response.status} ${response.statusText}`;
				throw new Error( errorMessage );
			}
			const responseBody = await response.text();
			if ( !responseBody ) {
				console.log( 'No content returned from server.' );
			} else {
				const data = JSON.parse( responseBody );
				console.log( 'Deleted successfully:', data );
			}


			await Swal.fire( {
				title: "Deleted",
				text: "This post was successfully deleted.",
				icon: "success",
				confirmButtonColor: "#d33",
			} );
			await fetchDataWithFilters();

		} else {
			await Swal.fire( {
				title: "Cancelled",
				text: "The deletion has been cancelled.",
				icon: "info",
				confirmButtonColor: "#4679cc",
			} );
		}
	} catch ( error ) {
		console.error( 'Error deleting:', error );
		await Swal.fire( {
			title: "Wrong",
			text: "An error occurred during the delete.",
			icon: "error",
			confirmButtonColor: "#d33",
		} );
	}
};


const presentationData = computed( () => {
	if ( route.name === 'list-presenation' && route.params.id ) {
		const item = jsonData.value?.find( ( item ) => item.identifier === route.params.id )
		return item ? { viewUrl: item._links.podcastSlideshowEdit?.href, editUrl: item._links.podcastSlideshow?.href } : null
	}
	return null
} )

const showList = computed( () => route.name === 'list' )


const loadMore = () => {
	currentPage.value += 1; // Increment the page
};

watch(
	() => route.query.page,
	(newPage) => {
		currentPage.value = parseInt(newPage as string) || 1;
		fetchDataWithFilters();
	}
);

// function goToPlaylist ( id?: number ) {
// 	router.push( { name: 'playlist', params: { id }, query: { ...route.query, page: currentPage.value } } );
// }
function goToPlaylist ( id?: number ) {
	stopInlineAudioPlayback()
	const baseUrl = AppConfig.detailsUrlTarget ? `${AppConfig.detailsUrlTarget}#/` : '#/'
	const queryParams = new URLSearchParams()

	Object.entries(route.query).forEach(([key, value]) => {
		if (typeof value === 'string') {
			queryParams.set(key, value)
			return
		}
		if (Array.isArray(value)) {
			queryParams.delete(key)
			value.forEach((entry) => {
				if (entry != null) {
					queryParams.append(key, String(entry))
				}
			})
		}
	})

	if (currentLng.value) {
		queryParams.set('lng', String(currentLng.value))
	}
	if (currentCollectionMode.value) {
		queryParams.set('collection-mode', String(currentCollectionMode.value))
	}
	if (currentTestyourself.value) {
		queryParams.set('testYourself', String(currentTestyourself.value))
	}
	if (currentPAGE_REQ_ID.value) {
		queryParams.set('PAGE_REQ_ID', String(currentPAGE_REQ_ID.value))
	}

	const queryString = queryParams.toString()
	window.location.href = `${baseUrl}playlist/${queryString ? `?${queryString}` : ''}`;
}

// function goToPresenation ( id: string ) {
// 	router.push( { name: 'list-presenation', params: { id }, query: { ...route.query, page: currentPage.value } } );
// }
function goToPresenation ( id: string ) {
	stopInlineAudioPlayback()
	const baseUrl = AppConfig.detailsUrlTarget ? `${AppConfig.detailsUrlTarget}#/` : '#/'
	window.location.href = `${baseUrl}details/${id}/presenation`;
}
// function goToQuizes () {
// 	router.push( { name: 'quizes', query: { ...route.query } } )
// }
function goToQuizes () {
	stopInlineAudioPlayback()
	const baseUrl = AppConfig.detailsUrlTarget ? `${AppConfig.detailsUrlTarget}#/` : '#/'
	window.location.href = `${baseUrl}quizes/`;
}
watch(currentPage, (newPage) => {
  router.replace({
    query: {
      ...route.query,
      page: newPage
    }
  });
});
watch(displayType, () => {
  fetchDataWithFilters();
});

const playingId = ref<string | null>( null );

const stopInlineAudioPlayback = () => {
	playingId.value = null;
	window.dispatchEvent(new CustomEvent('stop-inline-audio'));
};

const handleTogglePlayback = ( id: string ) => {
	if ( playingId.value === id ) {
		playingId.value = null;
	} else {
		playingId.value = id;
	}
};

watch(() => currentLng.value, () => {
	stopInlineAudioPlayback();
});
const refresh = (forceRefreshOnClose = false) => {
	const snapshot = lastRequestSnapshot.value
	if (!snapshot) {
		fetchDataWithFilters()
		return
	}

	fetchDataWithFilters(snapshot, {
		preserveOnMalformedEmpty: !forceRefreshOnClose,
		preserveWhenPageDrops: !forceRefreshOnClose
	})
};

const refreshListEvent = useEventBus<{ forceRefreshOnClose?: boolean }>('refresh-listview')
const stopListening = refreshListEvent.on((eventPayload) => {
	refresh(Boolean(eventPayload?.forceRefreshOnClose))
})


onMounted(async () => {
  if (!AppConfig.urls.getList) return;

	if ('detailsUrl' in route.query || 'detailsKey' in route.query) {
		const cleanedQuery = { ...route.query } as Record<string, any>
		delete cleanedQuery.detailsUrl
		delete cleanedQuery.detailsKey
		await router.replace({ query: cleanedQuery })
	}

	const pageFromQuery = parseInt(route.query.page as string) || 1;
	currentPage.value = pageFromQuery;

  await fetchDataWithFilters();
  await fetchStatusOptions();

  const savedDisplayType = localStorage.getItem('displayType') as 'list' | 'grid';
  if (savedDisplayType) {
    displayType.value = savedDisplayType;
  }
  document.addEventListener('refreshListView', () => {
    refresh();
  });
});


onBeforeUnmount( () => {
	unsubscribe();
	document.removeEventListener('refreshList', refresh);
	stopListening(); 

} )


</script>
<style scope>
#ListView .form-group {
	margin-bottom: 0 !important;
}
.disabled {
	opacity: 0.5;
	background-color:#ddd;	
	pointer-events: none;
	cursor:not-allowed;
}

</style>
